module.exports = __webpack_public_path__ + "img/hotel-11.78e0167f.jpeg";